import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { THEMES, getAvailableThemes } from '../config/themes';
import { Button } from './ui/button';

const ThemeSwitcher = ({ className = "" }) => {
  const { currentTheme, changeTheme, themeConfig } = useTheme();
  const availableThemes = getAvailableThemes();

  const handleThemeChange = (newTheme) => {
    changeTheme(newTheme);
  };

  const getThemeDisplayName = (themeId) => {
    switch(themeId) {
      case THEMES.ROCK:
        return 'Rock & Metal';
      case THEMES.LATINO:
        return 'Latino Music';
      case THEMES.STANDUP_CH:
        return 'Stand-Up Comedyss';
      case THEMES.WILDPEAKS:
        return 'Wild Peaks';
      default:
        return themeId;
    }
  };

  return (
    <div className={`theme-switcher ${className}`}>
      <div className="flex items-center space-x-2">
        <span className="text-sm text-gray-300">Theme:</span>
        <div className="flex space-x-1">
          {availableThemes.map((theme) => (
            <Button
              key={theme}
              variant={currentTheme === theme ? "default" : "outline"}
              size="sm"
              onClick={() => handleThemeChange(theme)}
              className={`text-xs ${
                currentTheme === theme 
                  ? 'bg-white text-black' 
                  : 'bg-transparent text-white border-gray-500 hover:bg-gray-800'
              }`}
            >
              {getThemeDisplayName(theme)}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ThemeSwitcher;
